/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(4),
  overflowX: 'auto',
}));

export const ModalPositionBox = styled(Box)(() => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}));
